import { CommanderThunkAction } from '@mews-commander/types';
import { showUpdateSnackbar } from '../../modules/alerts/actions/snackbars';
import { forceReload, logError } from '../../modules/app/actions/common';
import { networkStatusChangeOffline, networkStatusChangeOnline } from '../../modules/app/actions/networkStatus';
import { isAppOnline } from '../../modules/app/reducers/status';
import { FORCE_RELOAD_INTERVAL, SHOW_SNACKAR_INTERVAL } from '../websockets/constants';

export const connectionEstablished = (): CommanderThunkAction => (dispatch, getState) => {
    if (!isAppOnline(getState())) {
        dispatch(networkStatusChangeOnline());
    }
};

export const connectionLost = (): CommanderThunkAction => (dispatch, getState) => {
    if (isAppOnline(getState())) {
        dispatch(networkStatusChangeOffline());
    }
};

export const scheduleAppVersionChangedSnackbar = (): CommanderThunkAction => (dispatch) => {
    const showSnackbarInterval = Math.floor(SHOW_SNACKAR_INTERVAL + SHOW_SNACKAR_INTERVAL * Math.random());
    dispatch(
        logError({
            type: 'force-reload',
            message: 'App version change snackbar scheduled by version change.',
            context: { showSnackbarInterval },
        })
    );
    window.setTimeout(() => {
        dispatch(showUpdateSnackbar());

        const forcedReloadInterval = Math.floor(FORCE_RELOAD_INTERVAL + FORCE_RELOAD_INTERVAL * Math.random());
        dispatch(
            logError({
                type: 'force-reload',
                message: 'Forced reload scheduled by version change.',
                context: { forcedReloadInterval },
            })
        );
        window.setTimeout(() => dispatch(forceReload()), forcedReloadInterval);
    }, showSnackbarInterval);
};
